import React, { useEffect, useState } from 'react';
import '../../App.css';
import './user-control.css';
import { useTranslation } from 'react-i18next';
import CSS from 'csstype';
import { Col, Container, Row } from 'react-bootstrap';
import { useAppSelector } from '../../app/hooks';

// functions
import { APIPrefix } from '../../utils/functions';

// images
import userProfileIcon from '../../icons/user.512.png';

// classes
import Scrollbox from '../../tools/scrollbox';
import PleaseWait from '../../tools/please-wait';

//	--------------------------------------------------------------------------
//
//	P R O P E R T I E S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	C L A S S   D E F I N I T I O N
//
//	--------------------------------------------------------------------------

export default function UserProfile() {
  //
  //	--------------------------------------------------------------------------
  //
  //	R E D U X   S T A T E   H A N D L I N G
  //
  //	--------------------------------------------------------------------------

  // global state variables.
  const sG_preferredUsername: string | undefined = useAppSelector(
    (state) => state.global.preferredUsername,
  );
  const sG_username: string | undefined = useAppSelector(
    (state) => state.global.username,
  );

  //	--------------------------------------------------------------------------
  //
  //	D E C L A R A T I O N S
  //
  //	--------------------------------------------------------------------------

  // translation function
  const { t } = useTranslation();

  const [sGroups, setGroups] = useState<string[]>([]);
  const [sGroupsLoading, setGroupsLoading] = useState<boolean>(false);

  //	------------------------------------------------------------
  //
  //	Get the user profile information from the back end.
  //
  //	------------------------------------------------------------

  async function loadUserProfile() {
    //
    var urlCommand: string = APIPrefix() + '/v1/list_groups';

    try {
      //
      const apiResult = await fetch(urlCommand, {
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });
      if (apiResult.status === 200) {
        //
        var groups: string[] = [];

        const groupsJson = await apiResult.json();
        if (groupsJson !== undefined) {
          if ('groups' in groupsJson) {
            groups = groupsJson.groups;
          }
        }

        // update the state with the list of returned computer services.
        setGroups(groups);
        setGroupsLoading(false);
        //
      }
      //
    } catch (e) {
      console.log(e);
    }
  } // loadUserProfile

  //	--------------------------------------------------------------------------
  //
  //	H O O K S
  //
  //	--------------------------------------------------------------------------

  //	------------------------------------------------------------
  //
  //	Load the user profile information when the page loads.
  //
  //	------------------------------------------------------------

  useEffect(() => {
    //
    setGroupsLoading(true);
    loadUserProfile();
    //
  }, []);

  //	-------------------------------------------------
  //
  //	C O M P O N E N T   C O D E
  //
  //	-------------------------------------------------

  return (
    <Row
      role="region"
      aria-labelledby="user-profile-label"
      className="full-height-row gradient-background"
      style={{ padding: '0px 10px 0px 0px', width: '100%', margin: '0px 0px 0px 0px' }}
    >
      <Col
        sm={12}
        style={{
          padding: '0px',
          backgroundColor: 'transparent',
          borderWidth: '0px 3px 0px 0px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div style={{ flex: '0 0 15px' }} />
        <div className="form-title" id="user-profile-label" role="heading" aria-level={2}>
          {t('User Profile')}
        </div>
        <div style={{ flex: '0 0 25px' }} />
        <div style={{ flex: '1 1', flexDirection: 'row', display: 'flex' }}>
          <div style={{ flex: '0 0 10px' }} />
          <div
            className="panel-side text-colour"
            role="complementary"
            aria-label="User panel"
            data-maximised="T"
            data-dark-background="T"
            style={{
              flex: '0 0 200px',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              borderRadius: '10px',
              paddingLeft: '10px',
              alignItems: 'center',
            }}
          >
            <div style={{ flex: '0 0 20px' }} />
            <div
              style={{
                flex: '0 0 100px',
                width: '0 0 100px',
                border: '1pt solid #555',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img
                src={userProfileIcon}
                role="decoration"
                alt=""
                width="90"
                height="90"
              />
            </div>
            <div style={{ flex: '0 0 20px' }} />
            <div style={{ flex: '0 0 auto', fontSize: '1.2em' }}>{sG_username}</div>
            <div style={{ flex: '0 0 5px' }} />
            <div style={{ flex: '0 0 auto' }}>({sG_preferredUsername})</div>
            <div style={{ flex: '0 0 20px' }} />
          </div>
          <div style={{ flex: '0 0 40px' }} />
          <div
            style={{
              flex: '1 1',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div style={{ flex: '0 0 20px' }} />
            <Scrollbox
              direction="vertical"
              flex="1 1"
              width="100%"
              flexDirection="column"
            >
              {/*
               // iam groups.
               */}
              <div
                id="iam-groups-label"
                className="text-colour"
                style={{ flex: '0 0 auto' }}
              >
                {t('IAM Groups')}:
              </div>
              <div style={{ flex: '0 0 15px' }} />
              <div
                role="region"
                area-labelledby="iam-groups-label"
                style={{
                  flex: '1 1',
                  border: '1pt solid #555',
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '8px 8px 8px 8px',
                }}
              >
                <Scrollbox
                  direction="vertical"
                  flex="1 1"
                  width="100%"
                  flexDirection="column"
                >
                  <PleaseWait text="Loading" visible={sGroupsLoading} />
                  {sGroupsLoading === false &&
                    sGroups
                      .sort((a, b) => (a > b ? 1 : -1))
                      .map((item) => (
                        <div
                          className="text-colour"
                          style={{ flex: '0 0 auto', width: '100%' }}
                        >
                          {item}
                        </div>
                      ))}
                </Scrollbox>
              </div>
              <div style={{ flex: '0 0 5px' }} />
            </Scrollbox>
          </div>
        </div>
        <div style={{ flex: '0 0 10px' }} />
      </Col>
    </Row>
  );
  //
} // UserProfile
